export class RequestError extends Error {
  constructor(code, data, message, transactionId) {
    super();
    this.code = code || "";
    this.data = data || null;
    this.message = message || "";
    this.transactionId = transactionId || "";
  }
}
